// import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { GlobalWarningComponent } from '../global-warning/global-warning.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    imports: [RouterModule, MatSidenavModule, SidebarComponent, GlobalWarningComponent],
})
export class MainLayoutComponent implements OnInit {
    public isExpanded: boolean = false;

    @ViewChild('drawer') drawer?: MatDrawer;
    @ViewChild('drawerOverlay') overlay?: ElementRef;

    constructor() {}

    ngOnInit(): void {}

    toggleOverlay(): void {
        this.overlay?.nativeElement.toggleClass('overlay-inactive');
    }

    backdropClicked() {
        this.isExpanded = !this.isExpanded;

        if (!this.drawer) {
            return;
        }

        setTimeout(() => {
            !this.drawer?.opened ? this.drawer?.open() : (this.isExpanded = false);
        }, 0);
    }
}
